import { Button } from "../components/Button";
import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../components/PageContainer";
import { TitleBar } from "../components/TitleBar";
import { tMsg } from "../components/ToastNotifications";
import apiAgent from "../api/apiAgent";
import { changesSchema } from "../components/Publishing/atoms";
import { useAtomValue } from "jotai";
import { userAtom } from "../atoms";
import { AxiosResponse } from "axios";
import { addAnyNewPublishData } from "../components/Publishing/utils";
import { Link } from "react-router-dom";
import { HomePublishSection } from "../components/Publishing";
import {
  ClearMomentsButton,
  CustomDataImport,
} from "../components/CustomDataImport";

const SectionCard = ({ children }: { children: React.ReactNode }) => (
  <div className="w-full bg-black/10 p-8 flex flex-col gap-4">{children}</div>
);

const Home = (): JSX.Element => {
  const user = useAtomValue(userAtom);

  const checkValidation = async () => {
    const response = await apiAgent.Auth.validate();
    if (response.status === 200) {
      tMsg.success("Your login is valid");
    } else {
      tMsg.warning("Invalid login");
    }
  };

  return (
    <PageContainer>
      <PageContent className="flex flex-col gap-8">
        <TitleBar
          title={user?.username ? `Welcome ${user?.username}!` : "Welcome!"}
        />
        <div className="mb-2">Development test page</div>
        <SectionCard>
          <div className="flex gap-10 content-end">
            <div className="flex flex-col justify-between">
              <div className="font-bold">Moments</div>
              <div className="flex gap-2 text-sm">
                <Link to="/m/moments">
                  <Button>Manage moments</Button>
                </Link>
              </div>
            </div>
            <HomePublishSection appGroup="moment" />
          </div>
        </SectionCard>
        <SectionCard>
          <div className="flex gap-10 content-end">
            <div className="flex flex-col justify-between">
              <div className="font-bold">Settings</div>
              <div className="flex gap-2 text-sm">
                <Link to="/si/settings">
                  <Button>Modify Settings</Button>
                </Link>
              </div>
            </div>
            <HomePublishSection appGroup="settings" />
          </div>
        </SectionCard>
        <SectionCard>
          <div className="flex gap-2 text-xs">
            Test items:
            <Button onClick={() => checkValidation()}>Validate login</Button>
            <Button onClick={() => addAnyNewPublishData()}>
              Add any new publish data
            </Button>
          </div>
        </SectionCard>
        <SectionCard>
          <div className="font-bold">Moment Data Import</div>
          <div className="flex justify-between">
            <CustomDataImport modelName="moment" />
            <div className="flex gap-4">
              <ClearMomentsButton modelName="moment" />
            </div>
          </div>
        </SectionCard>
        <SectionCard>
          <div className="font-bold">Moment V2 Data Import</div>
          <div className="flex justify-between">
            <CustomDataImport modelName="landmark" />
            <div className="flex gap-4">
              <ClearMomentsButton modelName="landmark" />
            </div>
          </div>
        </SectionCard>
      </PageContent>
    </PageContainer>
  );
};

export default Home;
